import { render } from "./App.vue?vue&type=template&id=37067f4c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37067f4c&lang=scss"
script.render = render

export default script